/* photoFocal (iter105) — shared focal-point helper for photo thumbnails.

   Grid thumbnails must crop (object-cover) to stay tidy, but the crop
   window should protect faces. Default is an upper-center bias (portrait
   heads live in the top third); admins can override per photo via the
   `focal` field on the media row ('top' | 'center' | 'bottom'). */
export function focalPosition(m) {
  const f = (typeof m === 'string' ? m : (m && m.focal) || '').toLowerCase();
  if (f === 'top') return 'center 8%';
  if (f === 'center') return 'center 50%';
  if (f === 'bottom') return 'center 88%';
  return 'center 30%';
}

export const FOCAL_CYCLE = ['auto', 'top', 'center', 'bottom'];

export const FOCAL_LABELS = {
  auto: 'Focus · Auto',
  top: 'Focus · Top',
  center: 'Focus · Middle',
  bottom: 'Focus · Bottom',
};
